import styled from "styled-components"; 

export const  ContainerSplash = styled.div`
    position: absolute;
    z-index: 100;
    width: 100%;
    height: 100%;
    background: var(--color-primary-gradient);
    color: var(--color-white); 
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .logoHeader {
        width: 300px;
        height: 100px;
        object-fit: contain;
    }
    h1 {
        font-size: 18px;
        font-weight: 100;
    }
`;